var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTie = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61708 2.99609H14.3831C14.7298 2.99609 15.0518 3.17562 15.2341 3.47056C15.4163 3.7655 15.4329 4.13379 15.2779 4.44391L14.0009 6.99776H9.99924L8.72232 4.44391C8.56726 4.1338 8.58383 3.76551 8.7661 3.47058C8.94838 3.17564 9.27036 2.99609 9.61708 2.99609Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99906 6.99609L8.01294 18.5842C7.94954 18.9542 8.09852 19.3285 8.39879 19.5537L11.3999 21.8046C11.7556 22.0714 12.2448 22.0714 12.6005 21.8046L15.6016 19.5538C15.9019 19.3286 16.0509 18.9542 15.9875 18.5843L14.0013 6.99609",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTie);
export default ForwardRef;